import { apiFetch } from '../client';
import type { ListItem } from '../SharePointListClient';

/**
 * EF SubItems — children of an EF Item (AR-only today). Carry the cost-typing
 * flags from the client matrix (Costo Directo / Costo Indirecto, both Y/N).
 * Lean Supabase-backed CRUD via /api/estado-financiero/subitems.
 */
export type EfSubitemFields = {
  Nombre?: string | null;
  Status?: 'Activo' | 'Inactivo' | string | null;
  EfItemId?: number | null;
  EfItemNombre?: string | null;
  CostoDirecto?: boolean;
  CostoIndirecto?: boolean;
};
export type EfSubitemItem = ListItem<EfSubitemFields>;

type EfSubitemRow = {
  id: number;
  nombre: string;
  status: string;
  ef_item_id: number;
  ef_item_nombre: string | null;
  costo_directo: boolean;
  costo_indirecto: boolean;
  created_at: string;
  updated_at: string;
};

export type EfSubitemPayload = {
  nombre: string;
  efItemId: number;
  costoDirecto: boolean;
  costoIndirecto: boolean;
};

const toItem = (r: EfSubitemRow): EfSubitemItem => ({
  id: String(r.id),
  createdDateTime: r.created_at,
  lastModifiedDateTime: r.updated_at,
  fields: {
    Nombre: r.nombre,
    Status: r.status,
    EfItemId: r.ef_item_id,
    EfItemNombre: r.ef_item_nombre,
    CostoDirecto: r.costo_directo,
    CostoIndirecto: r.costo_indirecto,
  },
});

export async function listAllEfSubitems(): Promise<EfSubitemItem[]> {
  const rows = await apiFetch<EfSubitemRow[]>('/api/estado-financiero/subitems');
  return rows.map(toItem);
}

export async function createEfSubitem(payload: EfSubitemPayload): Promise<EfSubitemItem> {
  return toItem(
    await apiFetch<EfSubitemRow>('/api/estado-financiero/subitems', {
      method: 'POST',
      body: payload,
    }),
  );
}

export async function updateEfSubitem(
  id: string,
  payload: EfSubitemPayload,
): Promise<EfSubitemItem> {
  return toItem(
    await apiFetch<EfSubitemRow>(`/api/estado-financiero/subitems/${id}`, {
      method: 'PATCH',
      body: payload,
    }),
  );
}

export async function softDeleteEfSubitem(id: string): Promise<EfSubitemItem> {
  return toItem(
    await apiFetch<EfSubitemRow>(`/api/estado-financiero/subitems/${id}`, {
      method: 'PATCH',
      body: { status: 'Inactivo' },
    }),
  );
}
